module.exports = __webpack_public_path__ + "img/7.ec0b1fa9.svg";